import { FlexBox } from '@airship-platform/jam-web/components';
import Button from '@mui/material/Button';
import { z } from 'zod';
import ProductsFilterInput, {
  ProductsFilterInputSchema,
} from './ProductsFilterInput';

export const ProductsFilterFormSchema = z
  .object({
    matches: z.string().array(),
    pricebookTypes: z.string().array(),
    businessUnitIds: z.string().array(),
  })
  .merge(ProductsFilterInputSchema);

export type ProductsFilterFormInputs = z.infer<typeof ProductsFilterFormSchema>;

interface ProductsFilterFormProps {
  isLoading: boolean;
}

const ProductsFilterForm: React.FC<ProductsFilterFormProps> = ({
  isLoading,
}) => (
  <FlexBox flexDirection={['column', 'row']} gap={[2, 1]} alignItems={'center'}>
    <FlexBox
      flexDirection={['column', 'row']}
      alignItems={'center'}
      gap={2}
      width={'100%'}
    >
      <ProductsFilterInput sx={{ flex: [0, 1], width: '100%' }} />
    </FlexBox>
    <Button
      disabled={isLoading}
      type="submit"
      size="large"
      sx={{ width: ['100%', 'inherit'] }}
    >
      Search
    </Button>
  </FlexBox>
);

export default ProductsFilterForm;
